module.exports = window["Wistia"]["Preact"]["hooks"];